import {
	ASSETS_FOLDER,
	BASE_CONTENT_URL,
	CONFIG_FILENAME,
	FLOWS_V2_SDK_URL,
	WC_NAME
} from './constants';
// this lib allows us to re-register a custom element with the same name/class
// eslint-disable-next-line import/extensions

export const pathJoin = (...paths: string[]) =>
	paths.join('/').replace(/\/+/g, '/');

export const getSdkVersion = async (projectId: string) => {
	const configUrl = new URL(BASE_CONTENT_URL);
	configUrl.pathname = pathJoin(
		configUrl.pathname,
		projectId,
		ASSETS_FOLDER,
		CONFIG_FILENAME
	);

	const res = await fetch(configUrl, { cache: 'default' });

	return res.ok ? 'v2' : 'v1';
};

export const loadSdkV2 = () =>
	// @ts-ignore
	// eslint-disable-next-line import/no-unresolved, import/extensions
	import(/* webpackIgnore: true */ FLOWS_V2_SDK_URL);

// this fn patch the custom elements define fn when called,
// it prevents from descope-wc to be registered, and resolves with the descope-wc class
export const getDescopeWcDefineClass = () =>
	new Promise((resolve) => {
		const origDefine = customElements.define;
		customElements.define = (...args) => {
			if (args[0] === WC_NAME) {
				resolve(args[1]);
				customElements.define = origDefine;
			} else {
				origDefine.apply(customElements, args);
			}
		};
	});
